import axios from 'axios'
import config from '@/plugins/config'
import store from '@/store'
import router from '@/router'

// 成功拦截器
function successInterceptor (response) {
  return response
}

// 失败拦截器
function failedInterceptor (error) {
  if (error.response && error.response.data && error.response.data.status) {
    // 如果JWT无效，跳转登录
    if (error.response.data.status === 1101 || error.response.data.status === 403) {
      if (router.currentRoute.name !== 'Home') {
        console.log('Token失效，请重新登录')
        router.push({ name: 'BeforeLogin' })
          .then(() => {
            console.log('跳转成功')
          })
      }
    }
  }
  return Promise.reject(error)
}

export function buildAxios (option) {
  // console.log('option', option)
  const request = axios.create({
    baseURL: config.apiBaseUrl,
    timeout: option ? option.timeOut : config.apiTimeout,
    headers: {
      Token: store.state.token
    }
  })
  request.interceptors.response.use(successInterceptor, failedInterceptor)
  // console.log('buildAxios--', request.defaults.headers)
  return request
}

export function uploadFile (url, file, params, commonSubscribe, specificUrlInfoId) {
  const request = buildAxios()
  request.defaults.timeout = config.uploadTimeout
  request.defaults.headers['content-type'] = 'multipart/form-data'

  const formData = new FormData()
  formData.append('file', file)
  formData.append('payload', JSON.stringify(params))
  formData.append('commonSubscribe', commonSubscribe)
  if (specificUrlInfoId !== null && specificUrlInfoId !== undefined) {
    formData.append('specificUrlInfoId', specificUrlInfoId)
  }

  return request.post(url, formData)
}
